var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageTitle clearfix",class:{ border: _vm.isBorder }},[(_vm.title)?_c('div',{staticClass:"left position",style:(_vm.styles)},[_vm._v(_vm._s(_vm.title))]):_c('div',{staticClass:"left position"},[_vm._t("title")],2),_c('div',{staticClass:"right position"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }